import React, { useState, useEffect, useRef, useCallback } from 'react';
import { toast } from 'react-toastify';
import { useToast } from "../../Utils/toastContext";

import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import {
  get_user_accounts,
  get_user_info,
  get_customer_cash_ac,
  get_customer_securities,
  get_all_countries,
  get_beneficiary_list,
  get_beneficiary_info,
  currency_list,
  get_user_token_info,
  get_place_search,
  get_active_trans_req_step,
  app_bank_accounts,
  get_customer_account, 
  trans_request_cancel
} from '../../services/common';
import { XMarkIcon, DocumentTextIcon } from '@heroicons/react/24/solid';
import BeneficiaryModal from '../Customer/Beneficiary';

const Credit = () => {
  const navigate = useNavigate();
  const { showToast } = useToast(); 
  const BASE_URL = process.env.REACT_APP_EXISTING_BASE_URL || 'https://api.caprock.com.au';
  const [loading, setLoading] = useState(true);
  const [currentStep, setCurrentStep] = useState(1);
  const [activeTab, setActiveTab] = useState('account');
  const [userInfo, setUserInfo] = useState({});
  const [customerAccounts, setCustomerAccounts] = useState([]);
  const [cashAccounts, setCashAccounts] = useState([]);
  const [securitiesAccounts, setSecuritiesAccounts] = useState([]);
  const [countries, setCountries] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [selectedAccountType, setSelectedAccountType] = useState('');
  const [finalStep, setFinalStep] = useState(5);
  const [completedSteps, setCompletedSteps] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Form state
  const [formData, setFormData] = useState({
    ac_id: '',
    cashac_id: '',
    payment_reason: '',
    ac_ref_code: '',
    payer_type: '',
    payer_id: '',
    payer_name: '',
    payer_user_type: '',
    payer_company_reg_no: '',
    payer_nationality: '',
    payer_reg_country: '',
    payer_passport_no: '',
    payer_passport_expiry: '',
    payer_passport_country: '',
    payer_dob: '',
    payer_home_address: '',
    payer_email_id: '',
    payer_phone_no: '',
    payer_trust: '',
    payer_usa_citizen: '',
    payer_tax_resident_usa: '',
    payer_social_security_no: '',
    payer_tax_id: '',
    bank_id: '',
    payment_amount: '',
    payment_currency: '',
    payment_type: '',
    esign_name: '',
    esign_email_id: '',
    esign_phone_no: '',
    esign_dob: '',
    is_colour_passport: '',
    colour_passport: null,
    colour_passport_path: '',
    colour_passport_pbar: 0,
    colour_passport_pbar_p: '0%',
    colour_passport_pdiv: false,
    is_residence_proof: '',
    residence_proof: null,
    residence_proof_path: '',
    residence_proof_pbar: 0,
    residence_proof_pbar_p: '0%',
    residence_proof_pdiv: false,
    is_contract_proof: '',
    contract_proof: null,
    contract_proof_path: '',
    contract_proof_pbar: 0,
    contract_proof_pbar_p: '0%',
    contract_proof_pdiv: false,
    is_incorporation_certi: '',
    incorporation_certi: null,
    incorporation_certi_path: '',
    incorporation_certi_pbar: 0,
    incorporation_certi_pbar_p: '0%',
    incorporation_certi_pdiv: false,
    is_driver_license: '',
    driver_license: null,
    driver_license_path: '',
    driver_license_pbar: 0,
    driver_license_pbar_p: '0%',
    driver_license_pdiv: false
  });

  // File states
  const [files, setFiles] = useState({
    trans_proof: null,
    trust_deed: null,
    colour_passport: null,
    residence_proof: null,
    contract_proof: null,
    incorporation_certi: null,
    driver_license: null
  });

  const [fileNames, setFileNames] = useState({
    trans_proof: '',
    trust_deed: '',
    colour_passport: 'Select Passport',
    residence_proof: 'Select Residence Proof',
    contract_proof: 'Select Contract Proof',
    incorporation_certi: 'Select Certificate',
    driver_license: 'Select Driving License'
  });

  const [banks, setBanks] = useState([]);
  const [beneficiaries, setBeneficiaries] = useState([]);
  const [placeSuggestion, setPlaceSuggestion] = useState(false);
  const [placeList, setPlaceList] = useState([]);
  const [timer, setTimer] = useState(null);
  const [records, setRecords] = useState({});
  const [property, setPropertyAc] = useState([]);

  const [fum,setFum] = useState([]);

  const [myInvestment, setmyInvestment] = useState([]);

  const [custodian, setCustodian] = useState([]);

  const [commodities, setCommodities] = useState([]);

  const [crypto, setCrypto] = useState([]);

  const [beneficiaryI,setBeneficiaryInfo] = useState('');
  // Steps definition
  const steps = [
    { id: 1, name: 'Account Information', key: 'account' },
    { id: 2, name: 'Payer Information', key: 'payer' },
    { id: 3, name: 'Payment Details', key: 'payment_details' },
    { id: 4, name: 'E-Signature', key: 'e_signature' },
    { id: 5, name: 'Upload Proof', key: 'upload' }
  ];

  
  const toastRef = useRef(null);

  // Get token from localStorage
  const token = localStorage.getItem('systemToken') || '';

  useEffect(() => {
    document.title = "Account Credit Form || Caprock Merchant Platform";
    localStorage.setItem('active_page', 'account_form');

    if (!token) {
      navigate('/sign-in');
      return;
    }

    initializeData();
  }, []);

  useEffect(() => {
    // If we have completed steps, set to the last completed step + 1
    // unless we're already on a valid step
    if (completedSteps.length > 0) {
      const lastCompletedStep = Math.max(...completedSteps);
      const nextStep = lastCompletedStep + 1;
      
      // Only update if current step is invalid or not set
      if (!currentStep || (!completedSteps.includes(currentStep) && currentStep > nextStep)) {
        // console.log("Setting step to:", nextStep);
        setCurrentStep(nextStep);
        const stepInfo = steps.find(s => s.id === nextStep);
        if (stepInfo) {
          setActiveTab(stepInfo.key);
        }
      }
    } else {
      // No completed steps, start from step 1
      setCurrentStep(1);
      setActiveTab(steps[0]?.key || 'account');
    }
  }, [completedSteps, currentStep, steps]);

  useEffect(() => {
    if (formData.payer_type === 'existing') {
      const fetchBeneficiaries = async () => {
        try {
          const response = await get_beneficiary_list(token);
          if (response?.beneficiary) {
            setBeneficiaries(response.beneficiary || []);
          }
        } catch (error) {
          // console.error('Error fetching beneficiaries:', error);
          showToast('Failed to load beneficiaries', "error"); 
        }
      };
      fetchBeneficiaries();
    }
  }, [formData.payer_type, token]);

  // useEffect(() => {
  //   if (formData.payer_type === 'own') {
  //     fetchBanks();
  //   }
  // }, [formData.payer_type]);

  const getActiveStep = useCallback(async (id = 0) => {
    // console.log("I am calling getActiveStep");
    try {
      // Wait a bit for state updates to complete
      await new Promise(resolve => setTimeout(resolve, 100));
      
      // console.log("Current states before processing:", {
      //   cashAccounts,
      //   securitiesAccounts,
      //   property,
      //   myInvestment,
      //   custodian,
      //   commodities,
      //   crypto
      // });
      
      const token = localStorage.getItem('systemToken') || '';
      const response = await get_active_trans_req_step(token, 2);
      // console.log('API Response:', response);
      if (response?.success === 200 && response.old_request === 1) {
        const req = response.trans_request;
        // console.log('Response:', response);
        if (req.req_records) {
          // console.log('req_records:', req.req_records);
          const records = JSON.parse(req.req_records);
          // console.log('Parsed records:', records);
          records.trans_proof_url = req.trans_proof_url;
          records.trust_deed_url = req.trust_deed_url;
          records.colour_passport_url = req.colour_passport_url;
          records.residence_proof_url = req.residence_proof_url;
          records.contract_proof_url = req.contract_proof_url;
          records.incorporation_certi_url = req.incorporation_certi_url;
          records.driver_license_url = req.driver_license_url;
          
          // Determine the subaccounts based on the selected account type
          const map_ac = {
            1: "cash",
            3: "securities",
            2: "property",
            4: "my-investment",
            5: "custodian",
            6: "commodities",
            7: "crypto"
          }
          const accountType = map_ac[records.account.ac_id];
          let subAccounts = [];
          // console.log("Account Type:", accountType);
          // console.log("Available Accounts:", {
          //   cashAccounts,
          //   securitiesAccounts,
          //   property,
          //   myInvestment,
          //   custodian,
          //   commodities,
          //   crypto
          // });

          switch (accountType) {  // Use accountType directly
            case 'cash':
              subAccounts = cashAccounts;
              break;
            case 'property':
              subAccounts = property;
              break;
            case 'securities':
              subAccounts = securitiesAccounts;
              break;
            case 'my-investment':
              subAccounts = myInvestment;
              break;
            case 'custodian':
              subAccounts = custodian;
              break;
            case 'commodities':
              subAccounts = commodities;
              break;
            case 'crypto':
              subAccounts = crypto;
              break;
            default:
              subAccounts = [];
          }
          // console.log('SubAccounts:', subAccounts);

          // Set formData with parsed records
          
           // Find the subaccount with the matching cashac_id
           const matchingSubAccount = subAccounts.find(subAccounts => subAccounts.subac_id == records.account.cashac_id);
           var ac_ref_code = '';
          //  console.log("daiwdhiauwdiha",matchingSubAccount)
           if (matchingSubAccount) {
             // Extract the ac_ref_code from the matching subaccount
              ac_ref_code = matchingSubAccount.subac_reference_code;
           }
          //  console.log("ac_ref_code",ac_ref_code)
          setFormData(prev => {
            const updatedFormData = {
              ...prev,
              ...records.account,
              ac_id: records.account.ac_id || '', // Ensure ac_id is set
              cashac_id: records.account.cashac_id || '', // Ensure cashac_id is set
              ac_ref_code: ac_ref_code || '', // Ensure ac_ref_code is set
              subAccounts, // Set subAccounts based on account type
              ...records.payer,
              ...records.payment_details
            };
            // console.log('Setting FormData:', updatedFormData);
            return updatedFormData;
          });

          
          // Log formData after it is updated
          setTimeout(() => {
            console.log('Updated FormData:', formData);
          }, 0);

          setRecords(records);

          // console.log('FormData:', formData);

          const c_steps = req.req_completed_steps;
          if (c_steps) {
            setCompletedSteps(c_steps.split(",").map(Number));
          }
          // console.log("Records",records);
           
          setFinalStep(5);
          
          // console.log("req.req_current_step",req.req_current_step);
          setCurrentStep(req.req_current_step);
        } else {
          console.error('req_records is missing or empty');
        }
      } else {
        setCurrentStep(1);
      }
    } catch (error) {
      console.error('Error fetching active step:', error);
    }
  } ,[cashAccounts, securitiesAccounts, property, myInvestment, custodian, commodities, crypto]); // Add dependencies here


  useEffect(() => {
    console.log('Updated currentStep:', currentStep);
  }, [currentStep]);

  const [isDataInitialized, setIsDataInitialized] = useState(false);

  const initializeData = async () => {
    try {
      setLoading(true);
      
      // Fetch all data first
      const [
        cashResponse,
        securitiesResponse,
        propertyResponse,
        fumResponse,
        investmentResponse,
        custodianResponse,
        commoditiesResponse,
        cryptoResponse
      ] = await Promise.all([
        get_customer_cash_ac(token, 'fum,securities'),
        get_customer_securities(token),
        get_customer_account("property", token),
        get_customer_account("fum", token),
        get_customer_account("my-investment", token),
        get_customer_account("custodian", token),
        get_customer_account("commodities", token),
        get_customer_account("crypto", token)
      ]);

      // Update all states at once
      if (cashResponse?.success === 200) {
        setCashAccounts(cashResponse.cash_accounts || []);
      }
      if (securitiesResponse?.success === 200) {
        setSecuritiesAccounts(securitiesResponse.secuirty_accounts || []);
      }
      if (propertyResponse?.success === 200) {
        setPropertyAc(propertyResponse.ac_data?.subaccounts || []);
      }
      if (fumResponse?.success === 200) {
        setFum(fumResponse.ac_data?.subaccounts || []);
      }
      if (investmentResponse?.success === 200) {
        setmyInvestment(investmentResponse.ac_data?.subaccounts || []);
      }
      if (custodianResponse?.success === 200) {
        setCustodian(custodianResponse.ac_data?.subaccounts || []);
      }
      if (commoditiesResponse?.success === 200) {
        setCommodities(commoditiesResponse.ac_data?.subaccounts || []);
      }
      if (cryptoResponse?.success === 200) {
        setCrypto(cryptoResponse.ac_data?.subaccounts || []);
      }

      // Fetch other necessary data
      await Promise.all([
        fetchUserInfo(),
        fetchUserAccounts(),
        fetchCountries(),
        fetchCurrencies(),
        fetchBanks()
      ]);

      // Set initialization flag
      setIsDataInitialized(true);

    } catch (error) {
      console.error('Error initializing data:', error);
      showToast('Failed to load initial data', "error");
    } finally {
      setLoading(false);
    }
  };

  const fetchUserAccounts = async () => {
    try {
      const response = await get_user_accounts(token);
      if (response?.success === 200) {
          // console.log("user ac")
        setCustomerAccounts(response.accounts || []);
      }
    } catch (error) {
      console.error('Error fetching user accounts:', error);
    }
  };

  const cancelRequest = async() =>{
    // Show confirmation dialog
    const confirmed = window.confirm('Are you sure you want to cancel? All unsaved changes will be lost.');
    
    if (!confirmed) {
      return; // User clicked "No", so exit without canceling
    }

    try {
      const response = await trans_request_cancel(token, '2');
      if (response?.success === 200) {
        showToast(response.message, "success");
        navigate('/');
      }
    } catch (error) {
      console.error('Error canceling request:', error);
    }
  }



  const map_ac = {
    1: "cash",
    3: "securities",
    2: "property",
    4: "my-investment",
    5: "custodian",
    6: "commodities",
    7: "crypto"
  }

  const fetch_property_account = async () => {
    try {
      const response = await get_customer_account("property",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          // console.log("user property", response.ac_data.subaccounts);
          setPropertyAc(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching property accounts:', error);
    }
  }

  const fetch_fum_account = async () => {
    try {
      const response = await get_customer_account("fum",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          console.log("user customer", response.ac_data.subaccounts);
          
          setFum(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching fum accounts:', error);
    }
  }

  const fetch_my_investment_account = async () => {
    try {
      const response = await get_customer_account("my-investment",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          console.log("user investment", response.ac_data.subaccounts);

          setmyInvestment(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching investment accounts:', error);
    }
  }

  const fetch_custodian_account = async () => {
    try {
      const response = await get_customer_account("custodian",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          console.log("user custodian", response.ac_data.subaccounts);
      
          setCustodian(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching custodian accounts:', error);
    }
  }

  const fetch_commodities_account = async () => {
    try {
      const response = await get_customer_account("commodities",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          console.log("user commodities", response.ac_data.subaccounts);

          setCommodities(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching commodities accounts:', error);
    }
  }

  const fetch_crypto_account = async () => {
    try {
      const response = await get_customer_account("crypto",token);
      if (response?.success === 200 && response.ac_data?.subaccounts) {
          console.log("user crypto", response.ac_data.subaccounts);
           
          setCrypto(response.ac_data.subaccounts);
      }
    } catch (error) {
      console.error('Error fetching crypto accounts:', error);
    }
  }




  const fetchUserInfo = async () => {
    try {
      const response = await get_user_info(token);
      if (response?.success === 200) {
        const userInf = response.profile;
        userInf.join_date = userInf.join_date ? moment(userInf.join_date).format('DD MMM YYYY') : '';
        // console.log("user info",userInf)
        setUserInfo(userInf);
      }
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const fetchCashAccounts = async () => {
    try {
      const response = await get_customer_cash_ac(token, 'fum,securities');
      if (response?.success === 200 && response.cash_accounts) {
        console.log("user cashac", response.cash_accounts);
        
        setCashAccounts(response.cash_accounts);
      }
    } catch (error) {
      console.error('Error fetching cash accounts:', error);
    }
  };

  const fetchSecuritiesAccounts = async () => {
    try {
      const response = await get_customer_securities(token);
      if (response?.success === 200 && response.secuirty_accounts) {
        console.log("user sec", response.secuirty_accounts);
       
        setSecuritiesAccounts(response.secuirty_accounts);
      }
    } catch (error) {
      console.error('Error fetching securities accounts:', error);
    }
  };
  useEffect(() => {
    const allStates = {
      cashAccounts,
      securitiesAccounts,
      property,
      myInvestment,
      custodian,
      commodities,
      crypto
    };
    
    // console.log("State Updates:", allStates);
    
    // Check if all states have been initialized and have data
    const hasData = Object.values(allStates).every(state => Array.isArray(state));
    const hasAnyData = Object.values(allStates).some(state => state.length > 0);
    
    // console.log("All states initialized:", hasData);
    // console.log("Has any data:", hasAnyData);
    
    // Only proceed if we have initialized data and initialization is complete
    if (hasData && isDataInitialized) {
      // console.log("All states are ready, calling getActiveStep");
      getActiveStep();
    }
  }, [cashAccounts, securitiesAccounts, property, myInvestment, custodian, commodities, crypto, isDataInitialized, getActiveStep]);
  const fetchCountries = async () => {
    try {
      const response = await get_all_countries(token);
      // console.log('counbtrioes',response)
      if (response?.success === 1) {
        // console.log("user con");
        setCountries(response.data.countries || []);
      }
    } catch (error) {
      console.error('Error fetching countries:', error);
    }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await currency_list(token);
      if (response?.success === 200) {
        // console.log("user cur")
        setCurrencies(response.currencies || []);
      }
    } catch (error) {
      console.error('Error fetching currencies:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAccountTypeChange = (e) => {
    const value = e.target.value;
    // console.log("Selected account type:", value);
    setSelectedAccountType(value);
    
    // Determine the subaccounts based on the selected account type
    const accountType = map_ac[value];
    // console.log("Mapped account type:", accountType);
    
    let subAccounts = [];
    switch (accountType) {
      case 'cash':
        subAccounts = cashAccounts;
        // console.log("Selected cash accounts:", cashAccounts);
        break;
      case 'property':
        subAccounts = property;
        // console.log("Selected property accounts:", property);
        break;
      case 'securities':
        subAccounts = securitiesAccounts;
        // console.log("Selected securities accounts:", securitiesAccounts);
        break;
      case 'my-investment':
        subAccounts = myInvestment;
        // console.log("Selected investment accounts:", myInvestment);
        break;
      case 'custodian':
        subAccounts = custodian;
        // console.log("Selected custodian accounts:", custodian);
        break;
      case 'commodities':
        subAccounts = commodities;
        // console.log("Selected commodities accounts:", commodities);
        break;
      case 'crypto':
        subAccounts = crypto;
        // console.log("Selected crypto accounts:", crypto);
        break;
      default:
        subAccounts = [];
        // console.log("No account type matched, using empty array");
    }
    
    // console.log("Setting subAccounts:", subAccounts);
    
    setFormData(prev => {
      const updated = {
        ...prev,
        ac_id: value,
        cashac_id: '',
        ac_ref_code: '',
        subAccounts: subAccounts || []
      };
      // console.log("Updated form data:", updated);
      return updated;
    });
  };

  const handleSubAccountChange = (e) => {
    const selectedOption = e.target.options[e.target.selectedIndex];
    const refCode = selectedOption.getAttribute('data-ref-code');

    setFormData(prev => ({
      ...prev,
      cashac_id: e.target.value,
      ac_ref_code: refCode || ''
    }));
  };

  const handleFileChange = (e) => {
    try {
      const { name, files } = e.target;
      const file = files[0];
      
      // Safari-specific file validation
      if (!file) { 
        showToast('Please select a file', "error");
        return;
      }
      
      // Additional Safari file validation
      if (!file.name || file.name.trim() === '') {
        showToast('Invalid file selected. Please try again.', "error");
        e.target.value = '';
        return;
      }
      
      // Check if file is readable (Safari security check)
      if (file.size === 0) {
        showToast('Cannot read the selected file. Please try again.', "error");
        e.target.value = '';
        return;
      }
    
    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB in bytes
    if (file.size > maxSize) {
      // toast.error('File size must be less than 10MB. Please select a smaller file.');
      showToast('File size must be less than 10MB. Please select a smaller file.', "error");
      e.target.value = ''; // Reset file input
      return;
    }
    
    // Check file type
    const allowedTypes = [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'image/jpeg',
      'image/jpg',
      'image/png'
    ];
    
    const allowedExtensions = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
    const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
    
    if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
      showToast('Invalid file type. Please select a PDF, DOC, DOCX, JPG, JPEG, or PNG file.', "error");
      e.target.value = ''; // Reset file input
      return;
    }
    
    // Check if file name is valid
    if (file.name.length > 255) {
      showToast('File name is too long. Please rename the file and try again.', "error");
      e.target.value = ''; // Reset file input
      return;
    }
    
    // Check for special characters in file name
    const invalidChars = /[<>:"/\\|?*]/;
    if (invalidChars.test(file.name)) {
      showToast('File name contains invalid characters. Please rename the file and try again.', "error");
      e.target.value = ''; // Reset file input
      return;
    }

      // Safari-compatible file handling - avoid requestAnimationFrame issues
      setTimeout(() => {
        setFiles(prev => ({
          ...prev,
          [name]: file
        }));
        
        setFileNames(prev => ({
          ...prev,
          [name]: file.name
        }));
        
        setFormData(prev => ({
          ...prev,
          [name]: file,
          [`${name}_pdiv`]: true,
          [`${name}_pbar`]: 0,
          [`${name}_pbar_p`]: '0%'
        }));
        
        // Upload file asynchronously without blocking UI
        uploadFile(name, file);
      }, 100);
    } catch (error) {
      console.error('Error handling file change:', error);
      showToast('Error processing file. Please try again.', "error");
      // Reset the file input on error
      if (e.target) {
        e.target.value = '';
      }
    }
  };

  const handleRemoveFile = (fileType) => {
    setFiles(prev => ({
      ...prev,
      [fileType]: null
    }));
    setFileNames(prev => ({
      ...prev,
      [fileType]: ''
    }));
  };
  const [showModal, setShowModal] = useState(false);
  const [showBeneficiaryModal, setShowBeneficiaryModal] = useState(false);
  const [beneficiaryId, setBeneficiaryId] = useState(null);

  const viewBeneficiary = () => {
    const beneficiaryId = formData.payer_id;
    if (!beneficiaryId || beneficiaryId === '') {
      // toast.error('Please select valid beneficiary first.');
      showToast('Please select valid beneficiary first.', "error");
      return;
    }
    setBeneficiaryId(beneficiaryId);
    setShowBeneficiaryModal(true);
  };

 
  const fetchBanks = async (userToken) => {
    const token = localStorage.getItem('systemToken')
    try {
      // console.log("getching banks");
      
      const response = await app_bank_accounts(token); // Assuming get_user_accounts can fetch banks
      if (response?.bank_accounts) {
        setBanks(response?.bank_accounts || []); // Assuming response.accounts contains bank details
      }
    } catch (error) {
      console.error('Error fetching banks:', error);
      if (toastRef.current) {
        toastRef.current.error('Failed to load banks');
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Add form submission logic here
  };

  // Validation function
  const validateStep = (stepNumber) => {
    switch (stepNumber) {
      case 1:
        return formData.ac_id && formData.cashac_id && formData.payment_reason && formData.trans_proof;
      case 2:
        if (formData.payer_type === 'existing') {
          return formData.payer_id;
        } else if (formData.payer_type === 'own') {
          return formData.bank_id;
        } else if (formData.payer_type === 'new') {
          if (formData.payer_user_type === 'corporate') {
            return formData.payer_name && formData.payer_company_reg_no && formData.payer_nationality && formData.payer_reg_country;
          } else if (formData.payer_user_type === 'individual') {
            return formData.payer_name && formData.payer_passport_no && formData.payer_passport_expiry && formData.payer_passport_country && formData.payer_dob && formData.payer_home_address && formData.payer_email_id && formData.payer_phone_no;
          }
        }
        return false;
      case 3:
        return formData.payment_amount && formData.payment_currency && formData.payment_type &&
               (formData.payer_type === 'new' ? formData.bank_name && formData.bank_address && formData.bank_swift_code && formData.bank_ac_name && formData.bank_ac_no && formData.payer_ref_no && formData.your_ref_no && formData.payment_transmission_type : true);
      case 4:
        return formData.esign_name && formData.esign_email_id && formData.esign_phone_no && formData.esign_dob;
      case 5:
        return (formData.is_colour_passport === '1' ? formData.colour_passport : true) &&
               (formData.is_residence_proof === '1' ? formData.residence_proof : true) &&
               (formData.is_contract_proof === '1' ? formData.contract_proof : true) &&
               (formData.payer_user_type === 'corporate' ? (formData.is_incorporation_certi === '1' ? formData.incorporation_certi : true) : true) &&
               (formData.is_driver_license === '1' ? formData.driver_license : true);
      default:
        return false;
    }
  };


  const submitFinalRequest = async () => {
    // console.log('submitFinalRequest called');
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('req_type', '2'); // 2 for credit request

    try {
      const response = await fetch(`${BASE_URL}/trans-request-verify`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        showToast(result.message, "success");
        // Redirect to home page
        setTimeout(() => {
          navigate('/');
        }, 1000);
      } else {
        // toast.error(result.message);
        showToast(result.message || 'Failed to submit final request', "error");
      }
    } catch (error) {
      console.error('Error submitting final request:', error);
      showToast('Failed to submit final request', "error");
    }
  };

  const uploadFile = async (fieldName, file) => {
    // Safari-specific validations
    if (!file || !file.name) {
      showToast('Invalid file selected', "error");
      return;
    }
    
    if (!token) {
      showToast('Authentication error. Please refresh and try again.', "error");
      return;
    }
    
    const formData = new FormData();
    formData.append('file', file);
    formData.append('user_token', token);
    
    try {
      const response = await fetch(`${BASE_URL}/upload-file`, {
        method: 'POST',
        body: formData,
        // CORS headers for api.caprock.com.au
        headers: {
          'Accept': 'application/json',
        },
        // Cross-origin request configuration
        credentials: 'include',
        mode: 'cors'
      });
      
      const data = await response.json();
      
      if (data.success === 200) {
        setFormData(prev => ({
          ...prev,
          [`${fieldName}_path`]: data.file_path,
          [`${fieldName}_pbar_p`]: 'Upload Success'
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [`${fieldName}_pdiv`]: false,
          [`${fieldName}_pbar`]: 0,
          [`${fieldName}_pbar_p`]: 'Upload Failed'
        }));
        showToast(data.message || 'Failed to upload file', "error");
      }
    } catch (error) {
      console.error('Upload failed:', error);
      
      // Safari-specific error handling
      let errorMessage = 'Failed to upload file';
      if (error.name === 'TypeError' && error.message.includes('Failed to fetch')) {
        errorMessage = 'Network error. Please check your connection and try again.';
      } else if (error.message.includes('Operation not permitted')) {
        errorMessage = 'File access denied. Please try selecting the file again.';
      } else if (error.message.includes('abort')) {
        errorMessage = 'Upload cancelled. Please try again.';
      }
      
      setFormData(prev => ({
        ...prev,
        [`${fieldName}_pbar_p`]: 'Upload Failed',
        [`${fieldName}_pdiv`]: false
      }));
      showToast(errorMessage, "error");
    }
  };

  useEffect(() => {
    // console.log('Updated records state:', records);
  }, [records,currentStep]);


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  const canNavigateToStep = (stepNumber) => {
    // Can always navigate to completed steps
    if (completedSteps.includes(stepNumber)) {
      return true;
    }
    
    // Can navigate to current step
    if (stepNumber === currentStep) {
      return true;
    }
    
    // Can navigate to next step if previous step is completed
    const previousStep = stepNumber - 1;
    if (previousStep > 0 && completedSteps.includes(previousStep)) {
      return true;
    }
    
    return false;
  };

  const renderStepIndicator = () => (
    <div className="container-fluid">
      <ul className="list-none flex justify-between items-center my-8">
        {(steps || []).map((step, index) => {
          const stepNumber = index + 1;
          const isNavigable = canNavigateToStep(stepNumber);
          
          return (
            <li
              key={index}
              className={`relative flex-1 text-center ${
                currentStep === stepNumber 
                  ? 'text-blue-600' 
                  : isNavigable 
                    ? 'text-gray-700' 
                    : 'text-gray-400'
              }`}
              onClick={() => {
                if (isNavigable) {
                  // console.log("Navigating to step:", stepNumber);
                  setCurrentStep(stepNumber);
                  setActiveTab(step.key);
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }
              }}
              style={{ cursor: isNavigable ? 'pointer' : 'default' }}
            >
              <div className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center mb-2 border ${
                completedSteps.includes(stepNumber)
                  ? 'bg-black text-white'
                  : currentStep === stepNumber
                    ? 'border-blue-600 text-blue-600'
                    : isNavigable
                      ? 'border-gray-500'
                      : 'border-gray-300'
              }`}>
                {stepNumber}
              </div>
              <span className="hidden md:block">{step.name}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return renderAccountForm();
      case 2:
        return renderPayerInformation();
      // Add other cases for remaining steps
      case 3:
        return renderPaymentDetailsForm();

      case 4:
        return renderESignatureForm();

      case 5:
        return renderUploadProofForm();

      default:
        return null;
    }
  };

  const handlePrevious = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
      setActiveTab(steps[currentStep - 2]?.key || 'account');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleNext = async () => {
    if (validateStep(currentStep)) {
      // Submit current step data
      // Each submit function handles its own step progression
      switch (currentStep) {
        case 1:
          await submitForm1();
          break;
        case 2:
          await submitForm2();
          break;
        case 3:
          await submitForm3();
          break;
        case 4:
          await submitForm4();
          break;
        case 5:
          await submitForm5();
          break;
      }
      // Scroll to top after submission
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      showToast(`Please fill all required fields in ${steps[currentStep - 1]?.name}`, "error");
    }
  };

  const submitForm1 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('ac_id', formData.ac_id);
    formDataToSend.append('cashac_id', formData.cashac_id);
    formDataToSend.append('payment_reason', formData.payment_reason);
    
    if (files.trans_proof) {
      formDataToSend.append('trans_proof', files.trans_proof);
    }
  
    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-c1`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) { 
        showToast(result.message || 'Form 1 submitted successfully', "success");
        setCompletedSteps(prev => [...prev, 1]);
        setCurrentStep(2);
        setActiveTab('payer');
      } else {
        showToast(result.message || 'Form 1 submitting failed', "error");
      }
    } catch (error) {
      console.error('Error submitting form 1:', error);
      showToast('Failed to submit form', "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const submitForm2 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('payer_type', formData.payer_type);
    formDataToSend.append('payer_id', formData.payer_id);
    formDataToSend.append('bank_id', formData.bank_id);
    formDataToSend.append('payer_user_type', formData.payer_user_type);
    formDataToSend.append('payer_name', formData.payer_name);
    formDataToSend.append('payer_company_reg_no', formData.payer_company_reg_no);
    formDataToSend.append('payer_nationality', formData.payer_nationality);
    formDataToSend.append('payer_reg_country', formData.payer_reg_country);
    formDataToSend.append('payer_passport_no', formData.payer_passport_no);
    formDataToSend.append('payer_passport_expiry', formData.payer_passport_expiry);
    formDataToSend.append('payer_passport_country', formData.payer_passport_country);
    formDataToSend.append('payer_dob', formData.payer_dob);
    formDataToSend.append('payer_home_address', formData.payer_home_address);
    formDataToSend.append('payer_email_id', formData.payer_email_id);
    formDataToSend.append('payer_phone_no', formData.payer_phone_no);
    formDataToSend.append('payer_trust', formData.payer_trust);
    if (files.trust_deed) {
      formDataToSend.append('trust_deed', files.trust_deed);
    }
    formDataToSend.append('payer_usa_citizen', formData.payer_usa_citizen);
    formDataToSend.append('payer_social_security_no', formData.payer_social_security_no);
    formDataToSend.append('payer_tax_resident_usa', formData.payer_tax_resident_usa);
    formDataToSend.append('payer_tax_id', formData.payer_tax_id);
  
    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-c2`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        showToast(result.message, "success");

        setCompletedSteps(prev => [...prev, 2]);
        setCurrentStep(3);
        setActiveTab('payment_details');
      } else {
        showToast(result.message, "error");
      }
    } catch (error) {
      console.error('Error submitting form 2:', error);
      showToast('Failed to submit form', "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const submitForm3 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('payment_amount', formData.payment_amount);
    formDataToSend.append('payment_currency', formData.payment_currency);
    formDataToSend.append('payment_type', formData.payment_type);
    if (formData.payer_type === 'new') {
      formDataToSend.append('bank_name', formData.bank_name);
      formDataToSend.append('bank_address', formData.bank_address);
      formDataToSend.append('bank_swift_code', formData.bank_swift_code);
      formDataToSend.append('bank_ac_name', formData.bank_ac_name);
      formDataToSend.append('bank_ac_no', formData.bank_ac_no);
      formDataToSend.append('payer_ref_no', formData.payer_ref_no);
      formDataToSend.append('your_ref_no', formData.your_ref_no);
      formDataToSend.append('payment_transmission_type', formData.payment_transmission_type);
      formDataToSend.append('bank_officer_name', formData.bank_officer_name);
      formDataToSend.append('bank_officer_phone_no', formData.bank_officer_phone_no);
      formDataToSend.append('bank_officer_email_address', formData.bank_officer_email_address);
    }
  
    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-c3`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        showToast(result.message, "success");
        setCompletedSteps(prev => [...prev, 3]);
        setCurrentStep(4);
        setActiveTab('e_signature');
      } else {
        showToast(result.message, "error");
      }
    } catch (error) {
      console.error('Error submitting form 3:', error);
      showToast('Failed to submit form', "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const submitForm4 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('esign_name', formData.esign_name);
    formDataToSend.append('esign_email_id', formData.esign_email_id);
    formDataToSend.append('esign_phone_no', formData.esign_phone_no);
    formDataToSend.append('esign_dob', formData.esign_dob);
  
    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-c4`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        showToast(result.message, "success");
        // Always proceed to step 5 (Upload Proof) after E-Signature
        setCompletedSteps(prev => [...prev, 4]);
        setCurrentStep(5);
        setActiveTab('upload');
      } else {
        showToast(result.message, "error");
      }
    } catch (error) {
      console.error('Error submitting form 4:', error);
      showToast('Failed to submit form', "error");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  const submitForm5 = async () => {
    setIsSubmitting(true);
    const formDataToSend = new FormData();
    formDataToSend.append('user_token', token);
    formDataToSend.append('is_colour_passport', formData.is_colour_passport);
    if (formData.is_colour_passport === '1') {
      formDataToSend.append('colour_passport', formData.colour_passport);
    }
    formDataToSend.append('is_residence_proof', formData.is_residence_proof);
    if (formData.is_residence_proof === '1') {
      formDataToSend.append('residence_proof', formData.residence_proof);
    }
    formDataToSend.append('is_contract_proof', formData.is_contract_proof);
    if (formData.is_contract_proof === '1') {
      formDataToSend.append('contract_proof', formData.contract_proof);
    }
    if (formData.payer_user_type === 'corporate') {
      formDataToSend.append('is_incorporation_certi', formData.is_incorporation_certi);
      if (formData.is_incorporation_certi === '1') {
        formDataToSend.append('incorporation_certi', formData.incorporation_certi);
      }
    }
    formDataToSend.append('is_driver_license', formData.is_driver_license);
    if (formData.is_driver_license === '1') {
      formDataToSend.append('driver_license', formData.driver_license);
    }
  
    try {
      const response = await fetch(`${BASE_URL}/save-trans-request-c5`, {
        method: 'POST',
        body: formDataToSend
      });
      
      const result = await response.json();
      
      if (result.success === 200) {
        showToast(result.message, "success");
        await submitFinalRequest();
      } else {
        showToast(result.message, "error");
      }
    } catch (error) {
      console.error('Error submitting form 5:', error);
      showToast('Failed to submit form', "error");
    } finally {
      setIsSubmitting(false);
    }
  };




  const renderAccountForm = () =>(
    <div className="bg-white rounded-lg p-6">
    <h2 className="text-xl font-semibold mb-6">Account Information</h2>
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <label className="block text-gray-700 mb-2">Caprock Account Holder</label>
        <input
          type="text"
          value={userInfo.user_name || ''}
          readOnly
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black bg-gray-50"
        />
      </div>

      <div>
        <label className="block text-gray-700 mb-2">Select Account</label>
        <select
          name="ac_id"
          value={formData.ac_id}
          onChange={handleAccountTypeChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">Select Account Type</option>
          <option value="1">Cash Account</option>
          <option value="2"> Property </option>
          <option value="3">Securities</option>

          <option value="4">My Investment</option>
          <option value="5">Custodian</option>
          <option value="6">Commodities</option>
          <option value="7">Crypto</option>


        </select>
      </div>

      {formData.ac_id && (
        <div>
          <label className="block text-gray-700 mb-2">Select account to credit</label>
          <select
            name="cashac_id"
            value={formData.cashac_id}
            onChange={handleSubAccountChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">
              {formData.ac_id === '1' ? 'Select Cash Account' : 'Select Securities Account'}
            </option>
            {formData.subAccounts.map(account => (
              <option 
                key={account.subac_id} 
                value={account.subac_id}
                data-ref-code={account.subac_reference_code}
              >
                {account.subac_name}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Add Caprock Account Ref No. */}
      <div>
        <label className="block text-gray-700 mb-2">Caprock Account Ref No.</label>
        <input
          type="text"
          name="ac_ref_code"
          value={formData.ac_ref_code || ''}
          readOnly
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black bg-gray-50"
        />
      </div>

      {/* Add Reason for payment */}
      <div>
        <label className="block text-gray-700 mb-2">Reason for payment</label>
        <select
          name="payment_reason"
          value={formData.payment_reason}
          onChange={handleInputChange}
          className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
        >
          <option value="">Select Payment Reason</option>
          <option value="service">Service</option>
          <option value="capital_transfer">Capital Transfer</option>
          <option value="purchase">Purchase</option>
          <option value="direction_to_pay">Direction to Pay</option>
        </select>
      </div>

      {/* Add Upload proof of Transaction */}
      <div>
        <label className="block text-gray-700 mb-2">Upload proof of Transaction</label>
        <div className="relative">
          <input
            type="file"
            name="trans_proof"
            onChange={handleFileChange}
            className="hidden"
            id="trans_proof"
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
          />
          <label
            htmlFor="trans_proof"
            className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
          >
            {files.trans_proof ? (
              <span className="text-gray-700">{fileNames.trans_proof}</span>
            ) : (
              <span className="text-gray-500">Choose a file or drag & drop here</span>
            )}
          </label>
        </div>
        {files.trans_proof && (
          <div className="mt-2">
            <div className="flex items-center space-x-2">
              <DocumentTextIcon className="h-5 w-5 text-gray-500" />
              <span className="text-sm text-gray-700">{fileNames.trans_proof}</span>
              <button
                type="button"
                onClick={() => handleRemoveFile('trans_proof')}
                className="text-red-500 hover:text-red-700"
              >
                <XMarkIcon className="h-4 w-4" />
              </button>
            </div>
          </div>
        )}
      </div>
    </form>
  </div>

  );


  
  const renderPayerInformation = () => (
    <div className="bg-white rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-6">Payer Information</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">Payer Type</label>
          <select
            name="payer_type"
            value={formData.payer_type}
            onChange={(e) => {
              handleInputChange(e);
              setFinalStep(e.target.value === 'own' || e.target.value === 'existing' ? 4 : 5);
            }}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select payer type</option>
            <option value="own">Transfer from my own account</option>
            <option value="existing">Existing Payer</option>
            <option value="new">New Payer</option>
          </select>
        </div>

        {formData.payer_type === 'existing' && (
          <div>
            <label className="block text-gray-700 mb-2">
              Payer
              <button
                onClick={viewBeneficiary}
                className="ml-2 text-blue-600 hover:text-blue-800"
                type="button"
              >
                View beneficiary detail
              </button>
            </label>
            <select
              name="payer_id"
              value={formData.payer_id}
              onChange={handleInputChange}
              className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            >
              <option value="">Select Payer</option>
              {(beneficiaries || []).map(beneficiary => (
                <option key={beneficiary.beneficiary_id} value={beneficiary.beneficiary_id}>
                  {beneficiary.beneficiary_name}
                </option>
              ))}
            </select>
          </div>
        )}

        {formData.payer_type === 'own' && (
          <div>
            <label className="block text-gray-700 mb-2">
              Select external bank Account
            </label>
            <select
              name="bank_id"
              value={formData.bank_id || ''}
              onChange={handleInputChange}
              className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            >
              <option value="">Select Bank Account</option>
              {(banks || []).map(bank => (
                <option key={bank.id} value={bank.id}>
                  {bank.name}
                </option>
              ))}
            </select>
          </div>
        )}

        {formData.payer_type === 'new' && (
          <>
            <div>
              <label className="block text-gray-700 mb-2">Corporate or Individual</label>
              <select
                name="payer_user_type"
                value={formData.payer_user_type}
                onChange={handleInputChange}
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              >
                <option value="">Select type</option>
                <option value="corporate">Corporate</option>
                <option value="individual">Individual</option>
              </select>
            </div>

            {formData.payer_user_type === 'corporate' && (
              <>
                <div>
                  <label className="block text-gray-700 mb-2">Name of payer</label>
                  <input
                    type="text"
                    name="payer_name"
                    value={formData.payer_name}
                    onChange={handleInputChange}
                    placeholder="i.e. Jonaten"
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Company registration number of payer</label>
                  <input
                    type="text"
                    name="payer_company_reg_no"
                    value={formData.payer_company_reg_no}
                    onChange={handleInputChange}
                    placeholder="i.e. IT56789"
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Nationality of Payer</label>
                  <select
                    name="payer_nationality"
                    value={formData.payer_nationality}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  >
                    <option value="">Select Country</option>
                    {(countries || []).map(country => (
                      <option key={country.country_id} value={country.country_id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Country of registration of Payer</label>
                  <select
                    name="payer_reg_country"
                    value={formData.payer_reg_country}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  >
                    <option value="">Select your country</option>
                    {(countries || []).map(country => (
                      <option key={country.country_id} value={country.country_id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                </div>
              </>
            )}

            {formData.payer_user_type === 'individual' && (
              <>
                <div>
                  <label className="block text-gray-700 mb-2">Name of person making payment</label>
                  <input
                    type="text"
                    name="payer_name"
                    value={formData.payer_name}
                    onChange={handleInputChange}
                    placeholder="i.e. Jonaten"
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Passport number of payer</label>
                  <input
                    type="text"
                    name="payer_passport_no"
                    value={formData.payer_passport_no}
                    onChange={handleInputChange}
                    placeholder="i.e. L8989S446546"
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Passport expiry of payer</label>
                  <input
                    type="date"
                    name="payer_passport_expiry"
                    value={formData.payer_passport_expiry}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Country of issue of passport of payer</label>
                  <select
                    name="payer_passport_country"
                    value={formData.payer_passport_country}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  >
                    <option value="">Select your country</option>
                    {(countries || []).map(country => (
                      <option key={country.country_id} value={country.country_id}>
                        {country.country_name}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Date of Birth of Payer</label>
                  <input
                    type="date"
                    name="payer_dob"
                    value={formData.payer_dob}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Home address of Payer</label>
                  <input
                    type="text"
                    name="payer_home_address"
                    value={formData.payer_home_address}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Email address of Payer</label>
                  <input
                    type="email"
                    name="payer_email_id"
                    value={formData.payer_email_id}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Mobile/Cell Number of Payer</label>
                  <input
                    type="text"
                    name="payer_phone_no"
                    value={formData.payer_phone_no}
                    onChange={handleInputChange}
                    className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                  />
                </div>

                <div>
                  <label className="block text-gray-700 mb-2">Is the Payer a trust?</label>
                  <div className="flex items-center space-x-4">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_trust"
                        value="1"
                        checked={formData.payer_trust === '1'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_trust"
                        value="0"
                        checked={formData.payer_trust === '0'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>

                {formData.payer_trust === '1' && (
                  <div>
                    <label className="block text-gray-700 mb-2">Upload trust deed</label>
                    <input
                      type="file"
                      name="trust_deed"
                      onChange={handleFileChange}
                      className="w-full"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-gray-700 mb-2">Is the Payer a USA citizen?</label>
                  <div className="flex items-center space-x-4">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_usa_citizen"
                        value="1"
                        checked={formData.payer_usa_citizen === '1'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_usa_citizen"
                        value="0"
                        checked={formData.payer_usa_citizen === '0'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>

                {(formData.payer_usa_citizen === '1' || formData.payer_tax_resident_usa === '1') && (
                  <div>
                    <label className="block text-gray-700 mb-2">Social Security Number of Payer</label>
                    <input
                      type="text"
                      name="payer_social_security_no"
                      value={formData.payer_social_security_no}
                      onChange={handleInputChange}
                      className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-gray-700 mb-2">Is the Payer a tax resident of the USA?</label>
                  <div className="flex items-center space-x-4">
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_tax_resident_usa"
                        value="1"
                        checked={formData.payer_tax_resident_usa === '1'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">Yes</span>
                    </label>
                    <label className="inline-flex items-center">
                      <input
                        type="radio"
                        name="payer_tax_resident_usa"
                        value="0"
                        checked={formData.payer_tax_resident_usa === '0'}
                        onChange={handleInputChange}
                        className="form-radio"
                      />
                      <span className="ml-2">No</span>
                    </label>
                  </div>
                </div>

                {formData.payer_tax_resident_usa === '1' && (
                  <div>
                    <label className="block text-gray-700 mb-2">Payer Tax ID</label>
                    <input
                      type="text"
                      name="payer_tax_id"
                      value={formData.payer_tax_id}
                      onChange={handleInputChange}
                      className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
                    />
                  </div>
                )}
              </>
            )}
          </>
        )}
      </form>
    </div>
  );

  const renderPaymentDetailsForm = () => (
    <div className="bg-white rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-6">Payment Details</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">Payment Amount</label>
          <input
            type="number"
            name="payment_amount"
            value={formData.payment_amount}
            onChange={handleInputChange}
            placeholder="Enter amount"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Payment Currency</label>
          <select
            name="payment_currency"
            value={formData.payment_currency}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select currency</option>
            {(currencies || []).map(currency => (
              <option key={currency.currency_id} value={currency.currency_id}>
                {currency.currency_symbol} {currency.currency_name}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Payment Type</label>
          <select
            name="payment_type"
            value={formData.payment_type}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
          >
            <option value="">Select type</option>
            <option value="single">Single - One Off</option>
            <option value="recurring">Recurring</option>
          </select>
        </div>

        {formData.payer_type === 'new' && (
          <>
            <div>
              <label className="block text-gray-700 mb-2">Name of sending bank</label>
              <input
                type="text"
                name="bank_name"
                value={formData.bank_name}
                onChange={handleInputChange}
                placeholder="i.e. CITI Bank"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Address of sending bank</label>
              <input
                type="text"
                name="bank_address"
                value={formData.bank_address}
                onChange={handleInputChange}
                placeholder="i.e. Sea Link, Sydney"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Bank SWIFT code</label>
              <input
                type="text"
                name="bank_swift_code"
                value={formData.bank_swift_code}
                onChange={handleInputChange}
                placeholder="i.e. JJDH546"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Sending account name</label>
              <input
                type="text"
                name="bank_ac_name"
                value={formData.bank_ac_name}
                onChange={handleInputChange}
                placeholder="i.e. Jonaten"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Sending bank account number</label>
              <input
                type="text"
                name="bank_ac_no"
                value={formData.bank_ac_no}
                onChange={handleInputChange}
                placeholder="i.e. 3539 000556"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Payer reference number</label>
              <input
                type="text"
                name="payer_ref_no"
                value={formData.payer_ref_no}
                onChange={handleInputChange}
                placeholder="i.e. IG987982"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Your reference number</label>
              <input
                type="text"
                name="your_ref_no"
                value={formData.your_ref_no}
                onChange={handleInputChange}
                placeholder="i.e. IG987982"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Transmission Type</label>
              <select
                name="payment_transmission_type"
                value={formData.payment_transmission_type}
                onChange={handleInputChange}
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              >
                <option value="">Select type</option>
                <option value="swift_mt103">SWIFT MT103</option>
                <option value="rtgs">RTGS</option>
                <option value="swift_gpi">SWIFT GPI</option>
                <option value="bank_draft">Bank Draft</option>
                <option value="sblc_bg">SBLC/BG</option>
                <option value="dlc">DLC</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Bank officer name</label>
              <input
                type="text"
                name="bank_officer_name"
                value={formData.bank_officer_name}
                onChange={handleInputChange}
                placeholder="i.e. Bank officer name"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Bank officer phone number</label>
              <input
                type="text"
                name="bank_officer_phone_no"
                value={formData.bank_officer_phone_no}
                onChange={handleInputChange}
                placeholder="i.e. +4 455545665"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>

            <div>
              <label className="block text-gray-700 mb-2">Bank officer email address</label>
              <input
                type="email"
                name="bank_officer_email_address"
                value={formData.bank_officer_email_address}
                onChange={handleInputChange}
                placeholder="i.e. email@address.com"
                className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
              />
            </div>
          </>
        )}
      </form>
    </div>
  );
  
  const renderESignatureForm = ()=> (
    <div className="bg-white rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-6">E-Signature</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-gray-700 mb-2">Name of Account Holder</label>
          <input
            type="text"
            name="esign_name"
            value={formData.esign_name || ''}
            onChange={handleInputChange}
            placeholder="i.e. Jonaten"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Email Address of Caprock Account Holder</label>
          <input
            type="email"
            name="esign_email_id"
            value={formData.esign_email_id || ''}
            onChange={handleInputChange}
            placeholder="i.e. email@address.com"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Phone Number of Caprock Account Holder</label>
          <input
            type="text"
            name="esign_phone_no"
            value={formData.esign_phone_no || ''}
            onChange={handleInputChange}
            placeholder="i.e. 3539 000556"
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            required
          />
        </div>

        <div>
          <label className="block text-gray-700 mb-2">Date of Birth</label>
          <input
            type="date"
            name="esign_dob"
            value={formData.esign_dob || ''}
            onChange={handleInputChange}
            className="w-full p-2 border-b border-gray-300 focus:outline-none focus:border-black"
            required
          />
        </div>
      </form>
    </div>
  );

  const renderUploadProofForm = () => (
    <div className="bg-white rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-6">Upload Proof</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        {formData.is_driver_license !== '1' && (
          <div>
            <label className="block text-gray-700 mb-2">
              Certified Copy Colour Passport of Beneficiary Payer?
            </label>
            <div className="flex items-center space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_colour_passport"
                  value="1"
                  checked={formData.is_colour_passport === '1'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">Yes</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_colour_passport"
                  value="0"
                  checked={formData.is_colour_passport === '0'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">No</span>
              </label>
            </div>
            {formData.is_colour_passport === '1' && (
              <div className="mt-2">
                <div className="relative">
                <input
                  type="file"
                  name="colour_passport"
                  onChange={handleFileChange}
                    className="hidden"
                    id="colour_passport"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  <label
                    htmlFor="colour_passport"
                    className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
                  >
                    {files.colour_passport ? (
                      <span className="text-gray-700">{fileNames.colour_passport}</span>
                    ) : (
                      <span className="text-gray-500">Choose a file or drag & drop here</span>
                    )}
                  </label>
                </div>
                {files.colour_passport && (
                  <div className="mt-2">
                    <div className="flex items-center space-x-2">
                      <DocumentTextIcon className="h-5 w-5 text-gray-500" />
                      <span className="text-sm text-gray-700">{fileNames.colour_passport}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveFile('colour_passport')}
                        className="text-red-500 hover:text-red-700"
                      >
                        <XMarkIcon className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        <div>
          <label className="block text-gray-700 mb-2">
            Certified Copy Utility Bill Showing Proof of Residential Address of Payer (Included?)
          </label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="is_residence_proof"
                value="1"
                checked={formData.is_residence_proof === '1'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="is_residence_proof"
                value="0"
                checked={formData.is_residence_proof === '0'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">No</span>
            </label>
          </div>
          {formData.is_residence_proof === '1' && (
            <div className="mt-2">
              <div className="relative">
              <input
                type="file"
                name="residence_proof"
                onChange={handleFileChange}
                  className="hidden"
                  id="residence_proof"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
                <label
                  htmlFor="residence_proof"
                  className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
                >
                  {files.residence_proof ? (
                    <span className="text-gray-700">{fileNames.residence_proof}</span>
                  ) : (
                    <span className="text-gray-500">Choose a file or drag & drop here</span>
                  )}
                </label>
              </div>
              {files.residence_proof && (
                <div className="mt-2">
                  <div className="flex items-center space-x-2">
                    <DocumentTextIcon className="h-5 w-5 text-gray-500" />
                    <span className="text-sm text-gray-700">{fileNames.residence_proof}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveFile('residence_proof')}
                      className="text-red-500 hover:text-red-700"
                    >
                      <XMarkIcon className="h-4 w-4" />
                    </button>
                    </div>
                  </div>
              )}
                </div>
              )}
            </div>

        <div>
          <label className="block text-gray-700 mb-2">
            Copy of contract or invoice between Caprock Account Holder and Payer as proof of transaction (Included)?
          </label>
          <div className="flex items-center space-x-4">
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="is_contract_proof"
                value="1"
                checked={formData.is_contract_proof === '1'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">Yes</span>
            </label>
            <label className="inline-flex items-center">
              <input
                type="radio"
                name="is_contract_proof"
                value="0"
                checked={formData.is_contract_proof === '0'}
                onChange={handleInputChange}
                className="form-radio"
              />
              <span className="ml-2">No</span>
            </label>
          </div>
          {formData.is_contract_proof === '1' && (
            <div className="mt-2">
              <div className="relative">
                <input
                  type="file"
                  name="contract_proof"
                  onChange={handleFileChange}
                  className="hidden"
                  id="contract_proof"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                />
                <label
                  htmlFor="contract_proof"
                  className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
                >
                  {files.contract_proof ? (
                    <span className="text-gray-700">{fileNames.contract_proof}</span>
                  ) : (
                    <span className="text-gray-500">Choose a file or drag & drop here</span>
                  )}
                </label>
              </div>
              {files.contract_proof && (
                <div className="mt-2">
                  <div className="flex items-center space-x-2">
                    <DocumentTextIcon className="h-5 w-5 text-gray-500" />
                    <span className="text-sm text-gray-700">{fileNames.contract_proof}</span>
                    <button
                      type="button"
                      onClick={() => handleRemoveFile('contract_proof')}
                      className="text-red-500 hover:text-red-700"
                    >
                      <XMarkIcon className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>

        {formData.payer_user_type === 'corporate' && (
          <div>
            <label className="block text-gray-700 mb-2">
              Certified Certificate of Incorporation from Payer (Included)?
            </label>
            <div className="flex items-center space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_incorporation_certi"
                  value="1"
                  checked={formData.is_incorporation_certi === '1'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">Yes</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_incorporation_certi"
                  value="0"
                  checked={formData.is_incorporation_certi === '0'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">No</span>
              </label>
            </div>
            {formData.is_incorporation_certi === '1' && (
              <div className="mt-2">
                <div className="relative">
                  <input
                    type="file"
                    name="incorporation_certi"
                    onChange={handleFileChange}
                    className="hidden"
                    id="incorporation_certi"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  <label
                    htmlFor="incorporation_certi"
                    className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
                  >
                    {files.incorporation_certi ? (
                      <span className="text-gray-700">{fileNames.incorporation_certi}</span>
                    ) : (
                      <span className="text-gray-500">Choose a file or drag & drop here</span>
                    )}
                  </label>
                </div>
                {files.incorporation_certi && (
                  <div className="mt-2">
                    <div className="flex items-center space-x-2">
                      <DocumentTextIcon className="h-5 w-5 text-gray-500" />
                      <span className="text-sm text-gray-700">{fileNames.incorporation_certi}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveFile('incorporation_certi')}
                        className="text-red-500 hover:text-red-700"
                      >
                        <XMarkIcon className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {formData.is_colour_passport !== '1' && (
          <div>
            <label className="block text-gray-700 mb-2">
              Certified Copy of Drivers License of Payer (Included)?
            </label>
            <div className="flex items-center space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_driver_license"
                  value="1"
                  checked={formData.is_driver_license === '1'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">Yes</span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="is_driver_license"
                  value="0"
                  checked={formData.is_driver_license === '0'}
                  onChange={handleInputChange}
                  className="form-radio"
                />
                <span className="ml-2">No</span>
              </label>
            </div>
            {formData.is_driver_license === '1' && (
              <div className="mt-2">
                <div className="relative">
                  <input
                    type="file"
                    name="driver_license"
                    onChange={handleFileChange}
                    className="hidden"
                    id="driver_license"
                    accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  />
                  <label
                    htmlFor="driver_license"
                    className="cursor-pointer flex items-center justify-center w-full p-2 border-2 border-dashed border-gray-300 rounded-md hover:border-gray-400"
                  >
                    {files.driver_license ? (
                      <span className="text-gray-700">{fileNames.driver_license}</span>
                    ) : (
                      <span className="text-gray-500">Choose a file or drag & drop here</span>
                    )}
                  </label>
                </div>
                {files.driver_license && (
                  <div className="mt-2">
                    <div className="flex items-center space-x-2">
                      <DocumentTextIcon className="h-5 w-5 text-gray-500" />
                      <span className="text-sm text-gray-700">{fileNames.driver_license}</span>
                      <button
                        type="button"
                        onClick={() => handleRemoveFile('driver_license')}
                        className="text-red-500 hover:text-red-700"
                      >
                        <XMarkIcon className="h-4 w-4" />
                      </button>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </form>
    </div>
  );


  const renderNavigationButtons = () => (
          <div className="flex justify-end space-x-4 p-6">
            <button
              onClick={() => cancelRequest()}
              className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
        onClick={handlePrevious}
              className="px-6 py-2 border border-blue-500 rounded-md text-blue-500 hover:bg-blue-50"
              disabled={currentStep === 1 || isSubmitting}
            >
              Previous
            </button>
            <button
        onClick={handleNext}
              className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center justify-center"
              disabled={isSubmitting}
            >
              {isSubmitting ? (
                <>
                  <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  {currentStep === 5 ? 'Submitting...' : 'Saving...'}
                </>
              ) : (
                currentStep === 5 ? 'Finish' : 'Next'
              )}
            </button>
          </div>
  );

  return (
    
    <div className="min-h-screen bg-gray-50 p-4">
      <div className="max-w-7xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm">
          {renderStepIndicator()}
          {renderCurrentStep()}

          {renderNavigationButtons()}
        </div>
      </div>
      <BeneficiaryModal
        beneficiaryId={beneficiaryId}
        show={showBeneficiaryModal}
        onClose={() => setShowBeneficiaryModal(false)}
      />
    </div>
  );
};

export default Credit;
